import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    position: 'relative',
  }),
  divider: theme => ({
    width: '100%',
    borderBottomColor: theme.colors.VFDivider.tertiary,
    borderBottomWidth: 1,
    position: 'absolute',
    left: 16,
    bottom: 72,
  }),
});
